import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';

export const OFFERS_TAGS = Object.freeze({
  OFFERS: 'offers',
});

export const offersApiSlice = createApi({
  reducerPath: 'offersApiSlice',
  baseQuery,
  tagTypes: Object.values(OFFERS_TAGS),
  endpoints: (builder) => ({
    getOffers: builder.query({
      query: ({ apiManager, ...params }) => apiManager.get(params),
      providesTags: [OFFERS_TAGS.OFFERS],
    }),
    getOffer: builder.query({
      query: ({ apiManager, id }) => apiManager.show(id),
    }),
    createOffers: builder.mutation({
      query: ({ apiManager, ...rest }) => apiManager.create(rest),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return [OFFERS_TAGS.OFFERS];
      },
    }),
    deleteOffer: builder.mutation({
      query: ({ apiManager, ...rest }) => apiManager.delete(rest),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return [OFFERS_TAGS.OFFERS];
      },
    }),
    updateOffer: builder.mutation({
      query: ({ apiManager, ...rest }) => apiManager.update(rest),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return [OFFERS_TAGS.OFFERS];
      },
    }),
    uploadOfferImage: builder.mutation({
      query: ({ apiManager, id, data }) => apiManager.uploadImage(id, data),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return [OFFERS_TAGS.OFFERS];
      },
    }),
    deleteOfferImage: builder.mutation({
      query: ({ apiManager, id, data }) => apiManager.deleteImage(id, data),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return [OFFERS_TAGS.OFFERS];
      },
    }),
    generateOfferImage: builder.mutation({
      query: ({ apiManager, id }) => apiManager.generateImage(id),
    }),
  }),
});

export const {
  useGetOffersQuery,
  useGetOfferQuery,
  useCreateOffersMutation,
  useDeleteOfferMutation,
  useUpdateOfferMutation,
  useUploadOfferImageMutation,
  useDeleteOfferImageMutation,
  useGenerateOfferImageMutation,
} = offersApiSlice;
